import { render, staticRenderFns } from "./delivery_address.vue?vue&type=template&id=7b6d479e&scoped=true"
import script from "./delivery_address.vue?vue&type=script&lang=js"
export * from "./delivery_address.vue?vue&type=script&lang=js"
import style0 from "./delivery_address.vue?vue&type=style&index=0&id=7b6d479e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6d479e",
  null
  
)

export default component.exports